var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLevantamentoRegularizacao(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 107,
    height: 85,
    viewBox: "0 0 107 85",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_241_50)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M42.26 3C52.6724 3 62.6583 7.13631 70.021 14.499C77.3837 21.8617 81.52 31.8476 81.52 42.26V81.52H42.26C31.8476 81.52 21.8617 77.3837 14.499 70.021C7.13631 62.6583 3 52.6724 3 42.26V42.26C3 31.8476 7.13631 21.8617 14.499 14.499C21.8617 7.13631 31.8476 3 42.26 3V3Z",
    stroke: "black",
    strokeWidth: 6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.52 76.3H103.96V81.52",
    stroke: "black",
    strokeWidth: 6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.26 69.6901C57.4092 69.6901 69.69 57.4092 69.69 42.2601C69.69 27.1109 57.4092 14.8301 42.26 14.8301C27.1108 14.8301 14.83 27.1109 14.83 42.2601C14.83 57.4092 27.1108 69.6901 42.26 69.6901Z",
    stroke: "black",
    strokeWidth: 6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_241_50"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 106.96,
    height: 84.52,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLevantamentoRegularizacao);
export default __webpack_public_path__ + "static/media/levantamento_regularizacao.3328e71f5178eea4206637f1734c872e.svg";
export { ForwardRef as ReactComponent };